<template>
  <div>
    <div class="config-panel-header">
      <h2 class="text-h5 font-weight-bold mb-4" :style="{ color: $getColor('vuetifyColor1') }">
        <v-icon :color="$getColor('vuetifyColor1')" large class="mr-2">mdi-text-box-multiple</v-icon>
        Códigos SAP
      </h2>
      <p class="text-subtitle-1 text--secondary">
        Gestiona los códigos SAP disponibles para los centros de trabajo.
      </p>
    </div>
    <v-divider class="mb-6"></v-divider>
    <CreateCode class="mb-3 ml-3" v-if="workcenterId" :workcenterId="workcenterId" />
    <Codes class="pt-5" v-if="workcenterId" :workcenterId="workcenterId" />
    <!-- Add progress bar -->
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import CreateCode from '@/views/_FATDA/components/CreateCode.vue';
import Codes from '@/views/_FATDA/components/Codes.vue';

export default {
  name: 'codes-view',
  data() {
    return {
      loading: false,
      loaded: false,
      dataCountLoaded: 0,
      adminAvailable: false,
      items: [],
      count: 0,
      workcenterId: null,
    };
  },
  mounted() {
    if (this.$store.state.projectId === null) {
      if (this.$route.name !== 'SelectWorkCenter') {
        this.$router.push({ name: 'SelectWorkCenter' }).catch(() => {});
      }
    } else {
      this.workcenterId = this.$store.state.projectId;
      this.adminAvailable = this.$store.getters['auth/hasRole'](['ROLE_SUPER_ADMIN']);
    }
  },
  methods: {
  },
  components: {
    CreateCode,
    Codes,
  },
};
</script>
